export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/yugoria.544b236e.svg","height":40,"width":40};